import { render } from "./FeedbackPage.vue?vue&type=template&id=a2488ea2"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"
script.render = render

export default script